import { atom, useAtomValue, useSetAtom } from 'jotai';

interface ModifyOnChatMeta {
  message: Conversation.Message;
  conversation: Conversation.Conversation;
}

const modifyOnChatState = atom<ModifyOnChatMeta | null>(null);

export const useModifyOnChatValue = () => useAtomValue(modifyOnChatState);
export const useSetModifyOnChat = () => useSetAtom(modifyOnChatState);

export const useModifyOnChat = () => {
  const value = useModifyOnChatValue();
  const setValue = useSetModifyOnChat();

  const show = (meta: ModifyOnChatMeta) => {
    setValue(meta);
  };

  const hide = () => {
    setValue(null);
  };

  return {
    visible: !!value,
    meta: value,
    show,
    hide,
  };
};
